const SIZE_CLASS = {
  sm: 'h-9 px-4 text-xs',
  md: 'h-11 px-6 text-sm',
  lg: 'h-14 px-8 text-base',
} as const;

type AlertCTASize = keyof typeof SIZE_CLASS;

interface AlertCTAProps {
  label: string;
  href: string;
  size?: AlertCTASize;
}

export function AlertCTA({ label, href, size = 'md' }: AlertCTAProps) {
  return (
    <a
      href={href}
      className={[
        'inline-flex items-center justify-center rounded-lg font-semibold',
        'bg-alert text-alert-foreground',
        'transition-[colors,box-shadow] duration-fast ease-out-quart hover:bg-alert-600 hover:shadow-alert',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-alert',
        SIZE_CLASS[size],
      ].join(' ')}
    >
      {label}
    </a>
  );
}
